"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const recoil_1 = require("recoil");
const PanelSection_1 = __importDefault(require("../shared/PanelSection"));
const react_i18next_1 = require("react-i18next");
const reportElementTypes_1 = require("../../../domain/reportElementTypes");
const ReportTypeToggle_1 = __importStar(require("../shared/ReportTypeToggle"));
const ReportViewToggle_1 = __importDefault(require("../shared/ReportViewToggle"));
const NavBar_1 = __importDefault(require("../NavBar"));
const DashboardView_1 = __importDefault(require("../Views/DashboardView"));
const LookView_1 = __importDefault(require("../Views/LookView"));
const react_router_dom_1 = require("react-router-dom");
const MoveDashboardModal_1 = __importDefault(require("../Modals/MoveDashboardModal"));
const ReportBasePage = ({ title, getDashboardsFunction, getLooksFunction, headers, showViews = false, showPopular = false, showLastViewed = false, emptyState, t, }) => {
    const [reportSwitch] = (0, recoil_1.useRecoilState)(ReportTypeToggle_1.reportTypeSwitchState);
    const [errorState, setErrorState] = (0, react_1.useState)({ hasError: false, redirectUrl: '' });
    const handleErrors = (err) => {
        if (err.response.status === 404) {
            setErrorState({ hasError: true, redirectUrl: '/notfound' });
        }
        else {
            setErrorState({ hasError: true, redirectUrl: '/error' });
        }
    };
    if (errorState.hasError) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: errorState.redirectUrl });
    }
    return (react_1.default.createElement(NavBar_1.default, null,
        react_1.default.createElement(PanelSection_1.default, { routes: [{ displayName: t(title), path: '' }] },
            react_1.default.createElement(ReportTypeToggle_1.default, null),
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement(ReportViewToggle_1.default, { showDropdown: false }),
            react_1.default.createElement("br", null),
            reportSwitch === reportElementTypes_1.ReportElementTypes.Dashboard && (react_1.default.createElement(DashboardView_1.default, { getDashboardsFunction: getDashboardsFunction, headers: headers, showViews: showViews, showLastViewed: showLastViewed, showPopular: showPopular, emptyState: emptyState, handleErrors: handleErrors })),
            reportSwitch === reportElementTypes_1.ReportElementTypes.Look && (react_1.default.createElement(LookView_1.default, { getLooksFunction: getLooksFunction, headers: headers, showViews: showViews, showLastViewed: showLastViewed, showPopular: showPopular, emptyState: emptyState, handleErrors: handleErrors }))),
        react_1.default.createElement(MoveDashboardModal_1.default, null)));
};
exports.default = (0, react_i18next_1.withTranslation)()(ReportBasePage);
